

import { SYMBOL_ARROW_SIZE } from '@r-core/constants';

export const CreateBlueprintSymbols = (): React.ReactElement => {
	return (
		<>
			<symbol id="left-arrow" width={SYMBOL_ARROW_SIZE} height={SYMBOL_ARROW_SIZE} >
				<polygon points={`${SYMBOL_ARROW_SIZE},0 ${SYMBOL_ARROW_SIZE},${SYMBOL_ARROW_SIZE} 0,${SYMBOL_ARROW_SIZE / 2}`} fill="black" />
			</symbol>
			< symbol id="right-arrow" width={SYMBOL_ARROW_SIZE} height={SYMBOL_ARROW_SIZE} >
				<polygon points={`0,0 0,${SYMBOL_ARROW_SIZE} ${SYMBOL_ARROW_SIZE},${SYMBOL_ARROW_SIZE / 2}`} fill="black" />
			</symbol>
			< symbol id="up-arrow" width={SYMBOL_ARROW_SIZE} height={SYMBOL_ARROW_SIZE} >
				<polygon points={`0,${SYMBOL_ARROW_SIZE} ${SYMBOL_ARROW_SIZE},${SYMBOL_ARROW_SIZE} ${SYMBOL_ARROW_SIZE / 2},0`} fill="black" />
			</symbol>
			< symbol id="down-arrow" width={SYMBOL_ARROW_SIZE} height={SYMBOL_ARROW_SIZE} >
				<polygon points={`0,0 ${SYMBOL_ARROW_SIZE},0 ${SYMBOL_ARROW_SIZE / 2},${SYMBOL_ARROW_SIZE}`} fill="black" />
			</symbol>

			<symbol id="chevron-left" width="24" height="96">
				<path
					d="M24 0
						L4 48
						L24 96
						L19 96
						L0 48
						L19 0
						L24 0
						Z"
					fill="black"
				/>
			</symbol>
			<symbol id="chevron-top" width="96" height="24">
				<path
					d="M0 19
						L48 0
						L96 19
						L96 24
						L48 4
						L0 24
						L0 0
						Z"
					fill="black"
				/>
			</symbol>
			<symbol id="chevron-right" width="24" height="96">
				<path
					d="M0 0
						L19 48
						L0 96
						L4 96
						L24 48
						L4 0
						L0 0
						Z"
					fill="black"
				/>
			</symbol>
			<symbol id="chevron-down" width="96" height="24">
				<path
					d="M0 0
						L48 19
						L96 0
						L96 4
						L48 24
						L0 4
						L0 0
						Z"
					fill="black"
				/>
			</symbol>
		</>
	);
};
